import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_SKILLS_BEGIN](state) {
    state.skillsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_SKILLS_SUCCESS](state, skills) {
    state.skillsGetError = null;
    state.skills = skills;
    state.skillsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_SKILLS_ERROR](state, err) {
    state.skillsGetState = API_STATES.REQUEST_ERROR;
    state.skillsGetError = err;
  },
  //Delete Skill
  [types.DELETE_SKILL_BEGIN](state) {
    state.skillDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_SKILL_SUCCESS](state) {
    state.skillDeleteError = null;
    state.skillDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_SKILL_ERROR](state, err) {
    state.skillDeleteState = API_STATES.REQUEST_ERROR;
    state.skillDeleteError = err;
  },




  //Create Skill
  [types.CREATE_SKILL_BEGIN](state) {
    state.skillCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_SKILL_SUCCESS](state, data) {
    state.skillCreateError = null
    state.skillCreateState = API_STATES.REQUEST_SUCCESS
    state.skill=data
  },
  [types.CREATE_SKILL_ERROR](state, err) {
    state.skillCreateState = API_STATES.REQUEST_ERROR;
    state.skillCreateError = err;
  },


  //UPDATE Skill
  [types.UPDATE_SKILL_BEGIN](state) {
    state.skillUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_SKILL_SUCCESS](state, data) {
    state.skillUpdateError = null
    state.skill=data
    state.skillUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_SKILL_ERROR](state, err) {
    state.skillUpdateState = API_STATES.REQUEST_ERROR
    state.skillUpdateError = err
  },
  
  
  
  
  
  
  [types.ADD_USER_SKILL_BEGIN](state,userId) {
    state.userSkillUpdating.push(userId)
  },
  [types.ADD_USER_SKILL_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.userSkillUpdating, data.userId);
    state.userSkillUpdating.splice(index, 1);
    
    rootState.app.formData.userSkills.push(data)
    state.userSkillUpdateError = null
  },
  [types.ADD_USER_SKILL_ERROR](state, { err,userId }) {
    const index = findIndex(state.userSkillUpdating, userId);
    state.userSkillUpdating.splice(index, 1);
    state.userSkillUpdateError = err;
  },

  [types.DELETE_USER_SKILL_BEGIN](state, userId) {
    state.userSkillDeleting.push(userId);
  },
  [types.DELETE_USER_SKILL_SUCCESS](state, { userId, rootState }) {
    state.userSkillDeleteSuccessError = null;
    
    const index = findIndex(rootState.app.formData.userSkills, { userId });
    rootState.app.formData.userSkills.splice(index, 1)
    
    const index2 = findIndex(state.userSkillDeleting, userId);
    state.userSkillDeleting.splice(index2, 1);
  },
  [types.DELETE_USER_SKILL_ERROR](state, { err, userId }) {
    const index = findIndex(state.userSkillDeleting, userId);
    state.userSkillDeleting.splice(index, 1);
    state.userSkillDeleteSuccessError = err;
  }



};

export default mutations;